import { addDays } from 'date-fns';
import {  FlexDateDto } from './types'
import { fromDateToFlexDateDto } from './utils';

export const publicHolidays = {
    'at': [
        { year: 255, day: 1, month: 1, wday: 255 } as FlexDateDto, // neujahr
        { year: 255, day: 6, month: 1, wday: 255 } as FlexDateDto, // hl 3 könige
        { year: 255, day: 1, month: 5, wday: 255 } as FlexDateDto, // staatsfeiertag
        { year: 255, day: 15, month: 8, wday: 255 } as FlexDateDto, //Mariä Himmelfahrt        
        { year: 255, day: 26, month: 10, wday: 255 } as FlexDateDto, //Nationalfeiertag   
        { year: 255, day: 1, month: 11, wday: 255 } as FlexDateDto, //Allerheiligen
        { year: 255, day: 8, month: 12, wday: 255 } as FlexDateDto, //Maria Empfängnis
        { year: 255, day: 24, month: 12, wday: 255 } as FlexDateDto, //Hl. Abend
        { year: 255, day: 25, month: 12, wday: 255 } as FlexDateDto, //Christtag
        { year: 255, day: 26, month: 12, wday: 255 } as FlexDateDto, //Stefanitag
        { year: 255, day: 31, month: 12, wday: 255 } as FlexDateDto, //Silvester
    ]
}

export const isSupported = (locale: string) =>{
    return publicHolidays[locale] !== undefined;
}

const numberOfYears = 5;
export function getHolidays(locale: string) {
    
    const now = new Date();
    var ret = publicHolidays.at;
    for (let i = 0; i < numberOfYears; i++) {
        // oster sonntag
        const es = calcEasterSunday(now.getFullYear() + i);
        ret.push(fromDateToFlexDateDto(es));
        // oster montag
        const em = addDays(es, 1);
        ret.push(fromDateToFlexDateDto(em));
        // Christi Himmelfahrt
        const ch = addDays(es, 39);
        ret.push(fromDateToFlexDateDto(ch));
        // Pfingstmontag
        const pm = addDays(es, 50);
        ret.push(fromDateToFlexDateDto(pm));
        // Fronleichnam
        const fl = addDays(es, 60);
        ret.push(fromDateToFlexDateDto(fl));
    }

    return ret;
}

function calcEasterSunday(year: number): Date {

    const k = year / 100;
    const m = 15 + (3 * k + 3) / 4 - (8 * k + 13) / 25;
    const s = 2 - (3 * k + 3) / 4;
    const a = year % 19;
    const d = (19 * a + m) % 30;
    const r = d / 29 + (d / 28 - d / 29) * a / 11;
    const og = 21 + d - r;
    const sz = 7 - ((year + year / 4 + s) % 7);
    const oe = 7 - ((og - sz) % 7);

    const os = og + oe;

    if (os > 31)
        return new Date(year, 3, os - 31);
    else
        return new Date(year, 2, 31);
}